import React, {useRef, useEffect} from 'react'
import * as G2 from '@antv/g2'

G2.registerTheme('newTheme', {
  defaultColor: '#fff',
  padding: '10px',
  pieLabels: {
    defaultColor: '#fff'
  },
  innerLabels: {
    defaultColor: '#fff'
  },
  components: {
    defaultColor: '#fff'
  },
  shapes: {
    defaultColor: '#fff'
  },
  geometries: {
    defaultColor: '#fff'
  }
})

const Chart = ({data = [], className, padding, renderChart, style}) => {
  const dom = useRef()
  const instance = useRef()
  // 初始化图表
  useEffect(() => {
    const container = dom.current
    const {height, width} = container.getBoundingClientRect()
    instance.current = new G2.Chart({
      container,
      autoFit: true,
      height,
      width,
      padding,
    })
    instance.current.theme('newTheme')
  }, [])
  // 自己定制化的渲染
  useEffect(() => {
    const chartInstance = instance.current
    chartInstance.clear()
    if (renderChart && typeof renderChart === 'function') {
      renderChart(chartInstance, {data})
    } else {
      console.warn('renderChart function is required ')
    }
  }, [])
  return <div style={style} className={className} ref={dom} />
}

export default Chart
